import { ArrowLeftOutlined, SearchOutlined } from '@ant-design/icons';
import { Col, Divider, Input, Row} from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import SearchMainPage from './SearchMainPage';
import SearchNothingFound from './SearchNothingFound';
import {DIR_RTL} from "../../../constants/ThemeConstant";
import {useDispatch, useSelector} from "react-redux";
import { getSearchResult } from 'redux/actions';
import SearchedElements from './SearchedElements';
import CardSkeleton from './CardSkeleton';
import "./search.css";

function Search() {
    const skeleton = [0,1,2,3,4,5];
    const {theme:{direction, locale}, fetchedData: {searchResults}} = useSelector(state => state)
    const dispatch = useDispatch()
    const [value, setValue] = useState('')
    const [loading, setLoading] = useState(false)
    const [pickup, setPickup] = useState(false)
    const input = useRef(null);

    const changeInputValue = (e) => {
        dispatch(getSearchResult(`&search=${e.target.value}${pickup && ('&branchId='+pickup)}`))
        e.target.value && setLoading(true)
        setValue(e.target.value)
    }

    useEffect(()=>{
        window.scrollTo({top: 0, behavior: 'auto'});
        setPickup(localStorage.getItem('selected-mode')==='pickup' ? JSON.parse(localStorage.getItem('selected-branch')).id :'')
        input.current.focus();
    }, [])

    useEffect(()=>{
        setLoading(false)
    }, [searchResults])

    return (
        <div style={{height: '100%', overflowX: 'hidden', position: 'relative'}}>
            <div className='search-header'>
                <div onClick={()=>{
                    window.history.back();
                    // window.location.reload();
                }}>
                    <ArrowLeftOutlined rotate={direction === DIR_RTL ? 180 : 0} style={{fontSize: '24px', cursor: 'pointer', color: 'black'}}/>
                </div>
                <Input
                    ref={input}
                    value={value}
                    onChange={changeInputValue}
                    allowClear={true}
                    placeholder='Search' 
                    prefix={<SearchOutlined style={{fontSize: '20px', color: '#999999'}}/>} 
                    style={{fontSize: '16px',backgroundColor: '#F5F5F5'}}
                    className='searchInput'
                />
            </div>
            <Divider className='m-0'/>
            {/* <div className="searchBody"> */}
                {value===''&& !loading && <SearchMainPage/>}
                
                {(searchResults.length>0 && value!=='' && !loading) && <Row gutter={8} className="mx-3 my-4">
                    {searchResults?.map(item=><SearchedElements key={item.id} item={item} locale={locale}/>)}
                </Row>}
                
                {(searchResults.length===0 && value!=='' && !loading) && <SearchNothingFound/>}

                {/* -------------------------loading------------------------ */}
                { loading && <Row gutter={8} className="mx-3 my-4">
                    {skeleton.map(item=><Col lg={12} md={6} sm={8} xs={12} key={item}>
                        <CardSkeleton/>
                    </Col>)}
                </Row>}
            {/* </div> */}
        </div>
    );
}

export default Search;